import {
  FaAndroid,
  FaArrowAltCircleUp,
  FaBell,
  FaBullhorn,
  FaGift,
  FaHandsHelping,
  FaList,
  FaNewspaper,
  FaPhoenixFramework,
  FaPlus,
  FaSms,
  FaSlidersH,
  FaStore,
  FaUsers
} from "react-icons/fa"
import { BsShieldFillPlus } from "react-icons/bs"
import { LiaFileContractSolid } from "react-icons/lia"

const navItems = {
  subscribeAdmin: [
    {
      path: "/products",
      icon: <FaList />,
      title: "محصولات",
      requiredAccess: "viewProducts"
    },
    {
      path: "/add-product",
      icon: <FaPlus />,
      title: "افزودن اشتراک",
      requiredAccess: "addProduct"
    },
    {
      path: "/add-premium-contract",
      icon: <BsShieldFillPlus />,
      title: "افزودن سرویس ویژه",
      requiredAccess: "addPremiumContract"
    },
    {
      path: "/services",
      icon: <LiaFileContractSolid />,
      title: "سرویس ها",
      requiredAccess: "viewServices"
    },
    {
      path: "/users",
      icon: <FaUsers />,
      title: "کاربران",
      requiredAccess: "viewUsers"
    },
    {
      path: "/customer-service",
      icon: <FaHandsHelping />,
      title: "خدمات مشتریان",
      requiredAccess: "viewCustomerService"
    },
    {
      path: "/subscription-gifts",
      icon: <FaGift />,
      title: "هدیه",
      requiredAccess: "viewSubscriptionGifts"
    },
    {
      path: "/sms",
      icon: <FaSms />,
      title: "SMS",
      requiredAccess: "editSmsPrice"
    },
    {
      path: "/app-version",
      icon: <FaAndroid />,
      title: "نسخه اپ",
      requiredAccess: "viewAppVersion"
    },
    {
      path: "/platform-settings",
      icon: <FaSlidersH />,
      title: "تنظیمات محیط",
      requiredAccess: "subscribeAdmin"
    },
    {
      path: "/marketplace-notifications",
      icon: <FaBell />,
      title: "اعلان‌های پرداخت",
      requiredAccess: "subscribeAdmin"
    },
    {
      path: "/marketplace-decoration",
      icon: <FaStore />,
      title: "طراحی فروشگاه عمومی",
      requiredAccess: "subscribeAdmin"
    },
    {
      path: "/marketplace-content",
      icon: <FaBullhorn />,
      title: "محتوای فروشگاه عمومی",
      requiredAccess: "subscribeAdmin"
    },
    {
      path: "/role-management",
      icon: <FaArrowAltCircleUp />,
      title: "مدیریت دسترسی ها",
      requiredAccess: "viewRoleManagement"
    },
    {
      path: "/account-management",
      icon: <FaUsers />,
      title: "مدیریت پرسنل",
      requiredAccess: "viewAccountManagement"
    },
    {
      path: "/jobs",
      icon: <FaPhoenixFramework />,
      title: "Jobs",
      requiredAccess: "viewJobs"
    },
    {
      path: "/news-events",
      icon: <FaNewspaper />,
      title: "News & Events",
      requiredAccess: "viewNews"
    }
  ]
}

export default navItems
